/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Platform_HandleInputs */

const en_onboarding_platform_handle = /** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform Handle`)
};

const id_onboarding_platform_handle = /** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handle Platform`)
};

/** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */
const es_onboarding_platform_handle = en_onboarding_platform_handle;

/** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */
const fr_onboarding_platform_handle = en_onboarding_platform_handle;

/** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */
const de_onboarding_platform_handle = en_onboarding_platform_handle;

/** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */
const ja_onboarding_platform_handle = en_onboarding_platform_handle;

/** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */
const zh_onboarding_platform_handle = en_onboarding_platform_handle;

/** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */
const ar_onboarding_platform_handle = en_onboarding_platform_handle;

/** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */
const it_onboarding_platform_handle = en_onboarding_platform_handle;

/** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */
const ru_onboarding_platform_handle = en_onboarding_platform_handle;

/** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */
const pt_onboarding_platform_handle = en_onboarding_platform_handle;

/** @type {(inputs: Onboarding_Platform_HandleInputs) => LocalizedString} */
const ko_onboarding_platform_handle = en_onboarding_platform_handle;

/**
* | output |
* | --- |
* | "Platform Handle" |
*
* @param {Onboarding_Platform_HandleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const onboarding_platform_handle = /** @type {((inputs?: Onboarding_Platform_HandleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Platform_HandleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_platform_handle(inputs)
	if (locale === "es") return es_onboarding_platform_handle(inputs)
	if (locale === "fr") return fr_onboarding_platform_handle(inputs)
	if (locale === "de") return de_onboarding_platform_handle(inputs)
	if (locale === "ja") return ja_onboarding_platform_handle(inputs)
	if (locale === "zh") return zh_onboarding_platform_handle(inputs)
	if (locale === "ar") return ar_onboarding_platform_handle(inputs)
	if (locale === "id") return id_onboarding_platform_handle(inputs)
	if (locale === "it") return it_onboarding_platform_handle(inputs)
	if (locale === "ru") return ru_onboarding_platform_handle(inputs)
	if (locale === "pt") return pt_onboarding_platform_handle(inputs)
	return ko_onboarding_platform_handle(inputs)
});